import type { AxiosResponse } from "axios";
import type { HttpClient } from "@/services/baseClient";
import type { ApiResponse, MyLiveStreamsResponse } from "@/types";

export function createMyLiveStreamsApi({ client }: HttpClient) {
  async function getMyLiveStreams(): Promise<MyLiveStreamsResponse> {
    const response: AxiosResponse<ApiResponse<MyLiveStreamsResponse>> =
      await client.get("/users/me/live-streams");
    return response.data.data;
  }

  return { getMyLiveStreams };
}
